import { FC } from 'react'
import { Transition } from 'react-transition-group'
import { TransitionStatus } from 'react-transition-group/Transition'
import styled from 'styled-components'
import { Button } from './Button'
import { ExclamationIcon } from './icons/ExclamationIcon'

type ErrorDialogProps = {
  message: string
  onClose: () => void
}

export const ErrorDialog: FC<ErrorDialogProps> = (props) => {
  const { message, onClose } = props
  return (
    <StyledContainer isShow={!!message}>
      <Transition in={!!message} timeout={550}>
        {(state) => (
          <>
            <StyledWrap state={state}>
              <ExclamationIcon />
              <StyledMessageWrap>{message}</StyledMessageWrap>
              <StyledButtonWrap>
                <Button buttonType="text" onClick={onClose}>
                  OK
                </Button>
              </StyledButtonWrap>
            </StyledWrap>
            <Shadow onClick={onClose} state={state} />
          </>
        )}
      </Transition>
    </StyledContainer>
  )
}

const StyledContainer = styled.div<{ isShow: boolean }>`
  height: 100vh;
  top: 0px;
  left: 0px;
  display: flex;
  z-index: 9999;
  position: fixed;
  width: ${({ isShow }) => (isShow ? '100%' : 'auto')};
`

const Shadow = styled.div<{ state: TransitionStatus }>`
  opacity: ${({ state }) => (state === 'entering' || state === 'entered' ? 0.75 : 0)};
  background: rgb(0, 0, 0);
  flex: 2 1 0%;
  width: ${({ state }) => (state === 'exited' ? '0px' : '100vw')};
  transition: 0.2s;
  height: 100%;
  cursor: pointer;
`

const StyledWrap = styled.div<{ state: TransitionStatus }>`
  text-align: center;
  opacity: ${({ state }) => (state === 'entering' || state === 'entered' ? 1 : 0)};
  display: ${({ state }) => (state === 'exited' ? 'none' : 'block')};
  position: absolute;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 100;
  min-width: 350px;
  transition: 0.2s;
  border-radius: 5px;
  overflow: hidden;
  padding: 40px 20px 0 20px;
`

const StyledMessageWrap = styled.div`
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: pre-wrap;
`

const StyledButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  padding-right: 10px;
`
